export default __webpack_public_path__ + "static/media/idan-chaviv_shlemim.7368d99e.mp3";